import types from "./types";

const initialState = {
    sendComment: {},
    fetchComment: {},
    likeDisLikeComment: {},
    likeDisLikeProduct: {}
}

const discussReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.POST_COMMENT_RESP:
            return {
                ...state,
                sendComment: action.payload
            }
        case types.POST_COMMENT_CLEAR:
            return {
                ...state,
                sendComment: action.payload
            }
        case types.POST_DISLIKE_LIKE_COMMENT_RESP:
            return {
                ...state,
                likeDisLikeComment: action.payload
            }
        case types.POST_DISLIKE_LIKE_COMMENT_CLEAR:
            return {
                ...state,
                likeDisLikeComment: action.payload
            }
        case types.FETCH_COMMENT_RESP:
            return {
                ...state,
                fetchComment: action.payload
            }
        case types.FETCH_COMMENT_CLEAR:
            return {
                ...state,
                fetchComment: action.payload
            }
        case types.LIKE_DISLIKE_PRODUCT_RESP:
            return {
                ...state,
                likeDisLikeProduct: action.payload
            }
        case types.LIKE_DISLIKE_PRODUCT_CLEAR:
            return {
                ...state,
                likeDisLikeProduct: {}
            }
        default:
            return state;
    }
}

export default discussReducer